import { ShoppingBag, Phone, Mail, Star, ArrowRight } from "lucide-react";

const VNECK_IMG = "/products/keep-austin-cut-vneck.jpg";

export default function KeepAustinCut() {
  return (
    <section
      id="keep-austin-cut"
      data-testid="keep-austin-cut-section"
      className="relative py-24 md:py-32 bg-black overflow-hidden border-t border-border"
    >
      {/* Background accents */}
      <div className="absolute -top-32 right-0 w-[500px] h-[500px] bg-primary/8 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 left-1/4 w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container-ic relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-6 relative order-1">
            <div className="relative aspect-square w-full max-w-xl mx-auto">
              {/* Hairline frame */}
              <div className="absolute inset-0 border border-primary/30 translate-x-3 translate-y-3 pointer-events-none" />
              <div className="relative w-full h-full overflow-hidden bg-white">
                <img
                  src={VNECK_IMG}
                  alt="Keep Austin Cut V-neck tee — black with sage-green chest graphic"
                  className="absolute inset-0 w-full h-full object-cover"
                  data-testid="kac-image"
                />
              </div>
              {/* Limited edition tag */}
              <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1.5 text-[10px] uppercase tracking-[0.3em] font-bold flex items-center gap-1.5">
                <Star className="h-3 w-3 fill-primary-foreground" />
                Just Dropped
              </div>
              {/* Price tag */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-black border border-primary px-5 py-3 md:px-6 md:py-4 shadow-2xl">
                <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                  Active-Wear V-Neck
                </div>
                <div className="font-display text-3xl md:text-4xl font-black text-primary leading-none mt-1">
                  $32
                </div>
              </div>
            </div>
          </div>

          {/* Copy + CTAs */}
          <div className="lg:col-span-6 order-2">
            <div className="overline mb-5">
              <ShoppingBag className="inline h-3.5 w-3.5 mr-2 -mt-0.5" />
              Ironclad Active-Wear
            </div>
            <h2
              className="font-display italic text-white text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9]"
              data-testid="kac-headline"
            >
              Keep <br />
              <span className="text-primary">Austin</span> Cut.
            </h2>

            <p className="mt-6 text-lg text-foreground/85 leading-relaxed max-w-xl">
              The official Ironclad Active-Wear V-neck. Premium moisture-wicking
              fabric, slim athletic fit, and a bold grass-cut chest graphic.
              Available in <span className="text-white font-bold">Jet Black</span>,{" "}
              <span className="text-white font-bold">White</span>, and{" "}
              <span className="text-primary font-bold">Ironclad Green</span>.
            </p>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-foreground/80">
              <li className="flex items-center gap-2">
                <span className="h-1 w-1 bg-primary rounded-full" />
                Moisture-wicking jersey
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1 w-1 bg-primary rounded-full" />
                3 colorways available
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1 w-1 bg-primary rounded-full" />
                Tagless &amp; flat seams
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1 w-1 bg-primary rounded-full" />
                Made for Texas heat
              </li>
            </ul>

            {/* CTAs */}
            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href="mailto:ironcladatx@gmail.com?subject=Order%20%E2%80%94%20Keep%20Austin%20Cut%20V-Neck&body=Hi%20Ironclad%2C%20I'd%20like%20to%20order%20the%20Keep%20Austin%20Cut%20V-Neck%20Tee%20(%2432).%0A%0AColor%3A%20%5BBlack%20%2F%20White%20%2F%20Green%5D%0ASize%3A%20%5BS%20%2F%20M%20%2F%20L%20%2F%20XL%5D%0AQuantity%3A%20%5B%5D%0AName%3A%20%5B%5D%0AAddress%3A%20%5B%5D"
                className="btn-primary group"
                data-testid="kac-order-email"
              >
                Order Now
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="tel:5129480676"
                className="btn-outline"
                data-testid="kac-call"
              >
                <Phone className="h-4 w-4" /> Call to Order
              </a>
              <a
                href="/shop#apparel"
                className="text-xs uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors flex items-center gap-2 ml-1"
                data-testid="kac-shop-all"
              >
                <Mail className="h-3.5 w-3.5" />
                See full apparel line
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
